import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from 'react-bootstrap';

const InformacionPago = ({ informacionPago }) => {
    const isReady = informacionPago && Object.keys(informacionPago).length > 0;

    const getFormaPagoStyle = (formaPago) => {
        if (!formaPago) return {};
        
        const formasElectronicas = ['03', '04', '28', '29', '05'];
        const codigo = formaPago.substring(0, 2);
        const isElectronica = formasElectronicas.includes(codigo);
        return {
            color: isElectronica ? '#198754' : '#dc3545',
            fontWeight: '600'
        };
    };

    return (
        <div className="mb-4">
            <h6 className="fw-bold mb-3 border-bottom pb-2 text-uppercase text-secondary">
                INFORMACIÓN DEL PAGO
            </h6>
            
            <div className="table-responsive border rounded bg-white shadow-sm">
                <table className="table table-bordered table-sm table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                    <tbody>
                        <tr>
                            <th className="table-light w-25 align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Fecha de pago:</th>
                            <td className="align-middle w-25">{isReady ? (informacionPago?.fechaPago || '-') : <Placeholder animation="wave"><Placeholder xs={8} /></Placeholder>}</td>
                            <th className="table-light w-25 align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Forma de pago:</th>
                            <td className="align-middle w-25" style={isReady ? getFormaPagoStyle(informacionPago?.formaDePagoP) : {}}>
                                {isReady ? (informacionPago?.formaDePagoP || '-') : <Placeholder animation="wave"><Placeholder xs={6} /></Placeholder>}
                            </td>
                        </tr>
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Moneda Pago:</th>
                            <td className="align-middle">{isReady ? (informacionPago?.monedaP || '-') : <Placeholder animation="wave"><Placeholder xs={4} /></Placeholder>}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Versión Pagos:</th>
                            <td className="align-middle">{isReady ? (informacionPago?.versionPagos || '-') : <Placeholder animation="wave"><Placeholder xs={3} /></Placeholder>}</td>
                        </tr>
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Monto Total Pagos:</th>
                            <td className="align-middle">{isReady ? `$${informacionPago?.montoTotalPagos || '0.00'}` : <Placeholder animation="wave"><Placeholder xs={5} /></Placeholder>}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Monto:</th>
                            <td className="align-middle fw-bold">{isReady ? `$${informacionPago?.monto || '0.00'}` : <Placeholder animation="wave"><Placeholder xs={6} /></Placeholder>}</td>
                        </tr>
                        {informacionPago?.totalTrasladoBaseIVA16 && (
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Base IVA 16%:</th>
                            <td className="align-middle">${informacionPago.totalTrasladoBaseIVA16}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Impuesto IVA 16%:</th>
                            <td className="align-middle">${informacionPago.totalTrasladosImpuestoIVA16 || '0.00'}</td>
                        </tr>
                        )}
                        {informacionPago?.totalTrasladosBaseIVA8 && (
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Base IVA 8%:</th>
                            <td className="align-middle">${informacionPago.totalTrasladosBaseIVA8}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Impuesto IVA 8%:</th>
                            <td className="align-middle">${informacionPago.totalTrasladosImpuestoIVA8 || '0.00'}</td>
                        </tr>
                        )}
                        {informacionPago?.totalTrasladosBaseIVA0 && (
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Base IVA 0%:</th>
                            <td className="align-middle">${informacionPago.totalTrasladosBaseIVA0}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Impuesto IVA 0%:</th>
                            <td className="align-middle">${informacionPago.totalTrasladosImpuestoIVA0 || '0.00'}</td>
                        </tr>
                        )}
                        {informacionPago?.totalTrasladosBaseIVAExento && (
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Base IVA Exento:</th>
                            <td className="align-middle" colSpan="3">${informacionPago.totalTrasladosBaseIVAExento}</td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

InformacionPago.propTypes = {
    informacionPago: PropTypes.shape({
        versionPagos: PropTypes.string,
        montoTotalPagos: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalTrasladoBaseIVA16: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalTrasladosImpuestoIVA16: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        fechaPago: PropTypes.string,
        formaDePagoP: PropTypes.string,
        monedaP: PropTypes.string,
        monto: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default InformacionPago;
